import Cookies from 'js-cookie';
import api from '../../services/api';
import { jwtDecode } from 'jwt-decode';

export function loadCustomerConfigs() {
  const token = Cookies.get('accessToken');
  if (!token) return Promise.resolve(null);
  const decodedToken = jwtDecode(token);
  let customerId = decodedToken.CustomerId;
  let url = "Customers/CustomerConfigurations";
  return api.get(url)
    .then(response => {
      let returnData = JSON.stringify({
        data: response.data,
        expiry: Date.now() + 6 * 60 * 60 * 1000, // 6 hours
      });
      localStorage.setItem(customerId + '-' + 'CustomerConfig', returnData);
      return response.data;
    })
    .catch(error => {
      console.error('API request error:', error); // eslint-disable-line no-console
      return null;
    });
}

export function getConfigValue(configs, configType) {
  if (!configs) return '';
  const match = configs.find(c => c.customerConfigurationType.type === configType);
  if (!match) return '';
  return parseConfigValue(match.value);
}

export function parseConfigValue(config) {
  if (!isNaN(config) && config !== '') {
    return Number(config);
  } else if (config === "True" || config === "true") {
    return true;
  } else if (config === "False" || config === "false") {
    return false;
  } else {
    return config;
  }
}

export async function getCustomerConfig(configType) {
  const configs = await loadCustomerConfigsCached();
  return getConfigValue(configs, configType);
}

export async function loadCustomerConfigsCached() {
  const token = Cookies.get('accessToken');
  if (!token) return null;
  const decodedToken = jwtDecode(token);
  let customerId = decodedToken.CustomerId;

  let storedConfigs = localStorage.getItem(customerId + '-' + 'CustomerConfig');
  if (storedConfigs) {
    let parsedConfigs = JSON.parse(storedConfigs);
    if (parsedConfigs.expiry && Date.now() <= parsedConfigs.expiry) {
      return parsedConfigs.data;
    }
    localStorage.removeItem(customerId + '-' + 'CustomerConfig');
  }

  return await loadCustomerConfigs();
}

export function getCustomerConfigTypeId(configType) {
  switch (configType) {
    case "EnableCustomQRBanner":
      return 1;
    case "EnableProjectCreation":
      return 2;
    case "ShowToolId":
      return 3;
    case "TimonUsername":
      return 4;
    case "TimonPassword":
      return 5;
    case "TimonUrl":
      return 6;
    case "DKApiKey":
      return 7;
    case "DKWebhookSecret":
      return 8;
    case "DefaultPageSize":
      return 9;
    case "StolpiUsername":
      return 10;
    case "StolpiPassword":
      return 11;
    case "DisableCars":
      return 12;
    case "AllowAllUsersToReturn":
      return 13;
    case "EnablePreCreatedProjectAssignments":
      return 14;
    case "EnableManualProjectPriceSetting":
      return 15;
    case "EnableProjectPrices":
      return 16;
    case "EnableProjectTypes":
      return 17;
    case "UsePreCreatedAssignmentsFilteringInPlanner":
      return 18;
    case "EnableToolPriceTypes":
      return 20;
    case "BusinessCentralCustomersTenantId":
      return 21;
    case "BusinessCentralCustomersClientId":
      return 22;
    case "BusinessCentralCustomersClientSecret":
      return 23;
    case "BusinessCentralCustomersClientScope":
      return 24;
    case "BusinessCentralCustomersTokenUrl":
      return 25;
    case "BusinessCentralCustomersCompanyId":
      return 26;
    case "AllowUsersToMarkBroken":
      return 27;
    case "DKItemCode":
      return 28;
    case "EnableERPCostSync":
      return 29;
    case "EnableDayProjectAssignments":
      return 30;
    case "DayProjectAssignmentsCustomName":
      return 32;
    case "BusinessCentralCustomersLocationId":
      return 33;
    case "AllowLocationFilteringForTools":
      return 34;
    case "RequireQRScanForLoanRentReturns":
      return 35;
    case "AskForToolImageOnReturnForToolReservations":
      return 36;
    case "AllowToolReservaAndUnreserveWithourQRScan":
      return 37;
    case "AskForToolImageOnReturnForExternalToolReservations":
      return 38;
    case "EnableFutureReservationProjectAssignments":
      return 39;
    case "EnableMultiRentals":
      return 40;
    case "LoanRentCustomer":
      return 41;
    case "PreCreatedDayProjectAssignmentsCustomName":
      return 42;
    case "EnableProjectAssignmentTypes":
      return 43;
    case "EnableRentalsOnly":
      return 44;
    case "ForceProjectConnectionOnRentals":
      return 45;
    case "PickToolsInProjectCostReport":
      return 46;
    case "ReglaUsername":
      return 47;
    case "ReglaPassword":
      return 48;
    case "EnableTimeRegistration":
      return 49;
    case "EnableTimesheetAdjustments":
      return 50;
    case "EnableQRScanForCarToolAssignment":
      return 51;
    case "AutoClockOutTime":
      return 52;
    case "ForceEndCustomerSelectionOnProjectCreation":
      return 53;
    case "EnableEndCustomers":
      return 54;
    case "BusinessCentralCustomersEnvironment":
      return 55;
    case "AllowAssigningToolToOtherUser":
      return 56;
    case "EnableGolf":
      return 57;
    case "DefaultGolfCourseId":
      return 58;
    case "VerklagClientId":
      return 59;
    case "VerklagClientSecret":
      return 60;
    case "AllowAdminMoveTimesheetEntry":
      return 61;
    case "RequireRepairNotes":
      return 62;
    case "AllowUsersToAddRemoveCarTools":
      return 63;
    case "EnableExcelExport":
      return 64;
    case "EnableSimplifiedTimeRegistration":
      return 65;
    case "RequireGpsClockIn":
      return 66;
    case "AdjustedClockInTime":
      return 67;
    case "EnableCommentsOnTimesheetEntries":
      return 68;
    case "AskForToolImageOnReturnForToolReservationsAfterDays":
      return 69;
    case "EnableGPS":
      return 70;
    case "SalaryPeriodStartDay":
      return 71;
    case "ProjectDataPublisher":
      return 72;
    case "HusasmidjanUsername":
      return 73;
    case "HusasmidjanPassword":
      return 74;
    case "EnableUserGroups":
      return 75;
    case "EnableToolUtilizationReport":
      return 76;
    case "EnableRevenueReport":
      return 77;
    case "EnableLaborByProjectReport":
      return 78;
    case "EnableToolDowntimeReport":
      return 79;
    case "EnableOverdueReservationsReport":
      return 80;
    case "EnableAbsenceReport":
      return 81;
    case "EnableAssetRoiReport":
      return 82;
    case "EnableEndCustomerBillingReport":
      return 83;
    case "AutoDeductBreakMinutes":
      return 84;
    case "AutoDeductBreakThresholdHours":
      return 85;
    case "EnableBreakButton":
      return 86;
    case "EnableTimesheetReminders":
      return 87;
    case "UnnurClientId":
      return 88;
    case "UnnurClientSecret":
      return 89;
    case "UnnurUrl":
      return 90;
    case "PlannerDefaultView":
      return 91;
    case "OnlyShowUsersWithAssignmentsInPlanner":
      return 92;
    case "EnableAssignmentCreationInPlannerMonthView":
      return 93;
    case "EnableProjectAssignmentMultiplierInPlanner":
      return 94;
    case "DisableRoutinesInPlanner":
      return 95;
    case "UseAssignmentStatusColorsInPlanner":
      return 96;
    case "EnablePlanner":
      return 97;
    case "DisableTaskCreationInPlanner":
      return 98;
    case "DisableToolsInPlanner":
      return 99;
    case "OnlyShowPreCreatedAssignmentsInPlanner":
      return 100;
    case "EnableToolReminders":
      return 101;
    case "TimeRegistrationDefaultAppScreen":
      return 102;
    case "TimesheetReminderTime":
      return 103;
    case "EnableProjectPhases":
      return 104;
    case "EnableTimeRegistrationSyncToERP":
      return 105;
    case "DKTimeRegSicknessMapping":
      return 106;
    case "DKTimeRegChildSicknessMapping":
      return 107;
    case "DKTimeRegVacationMapping":
      return 108;
    case "DKTimeRegPaidLeaveMapping":
      return 109;
    case "DKTimeRegUnpaidLeaveMapping":
      return 110;
    case "DKTimeRegParentalLeaveMapping":
      return 111;
    case "DKTimeRegAfterHoursTarget":
      return 112;
    case "DKTimeRegRedDayHoursTarget":
      return 113;
    case "DKTimeRegWorkEntriesBillable":
      return 114;
    case "EnableAbsenceView":
      return 115;
    case "EnableAbsenceSyncToERP":
      return 116;
    case "BusinessCentralTimeRegItems":
      return 117;
    case "BusinessCentralTimeRegDefaultItem":
      return 118;
    case "BusinessCentralTimeRegOvertimeItem":
      return 119;
    case "BusinessCentralTimeRegAfterHoursTarget":
      return 120;
    case "BusinessCentralTimeRegRedDayHoursTarget":
      return 121;
    case "BusinessCentralCostItem":
      return 122;
    case "EnableEndOfDayTimeRegistration":
      return 123;
    case "EnableUnfinishedTimeRegistrationDaysInOverview":
      return 124;
    case "EnableCustomOvertimeSchedule":
      return 125;
    case "AllowAssignedUsersToEditVehicles":
      return 126;
    case "EnableAutomaticERPSyncForTimeRegistrationEntries":
      return 127;
    case "AllowUsersToEditAndDeleteOwnTimesheetEntries":
      return 128;
    case "EnableReferenceInTimeRegistration":
      return 129;
    case "SidebarColor":
      return 130;
    default:
      return 0;
  }
}

// Default screen when the app opens: the user's own choice (Notendastillingar), else time
// registration if the customer has TimeRegistrationDefaultAppScreen enabled, else My Tools.
// The own choice only counts while time registration is on — the setting is hidden otherwise.
export async function getDefaultAppScreen() {
  if (await getCustomerConfig('EnableTimeRegistration') === true) {
    try {
      const r = await api.get('/User/me/default-app-screen');
      const own = r.data?.defaultAppScreen;
      if (own === 'time-registration') return '/time-registration';
      if (own === 'mytools') return '/mytools';
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  }
  const enabled = await getCustomerConfig('TimeRegistrationDefaultAppScreen');
  return enabled === true ? '/time-registration' : '/mytools';
}
